// lib
import { useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { calcSwitchContext, visibleSwitches } from '@aytm/app/stats/page/sidebar/components/lib/switches'

// styles
import style from '@aytm/app/stats/page/sidebar/components/styles/Sidebar.module.scss'

const SidebarSwitches = ({ model, features, currentPanel, onPanelChange }) => {
  const ctx = calcSwitchContext({
    features,
    isReportVirtual: model.isReportVirtual,
    isReportXpert: model.isReportXpert
  })

  const counts = useMemo(
    () => ({
      reports: model.reports.reduce((acc, cur) => acc + (cur.changed ? 1 : 0), 0),
      filters: null !== model.filtersPattern && 0 < model.filtersPattern.length ? 1 : 0,
      weighting: null !== model.weighting && model.weighting.active
    }),
    [model.reports, model.filtersPattern, model.weighting]
  )

  return (
    <>
      {visibleSwitches(ctx).map(item => (
        <div
          id={`stat-sidebar-switch-${item.panel}`}
          key={item.panel}
          data-applied={item.applied ? Boolean(item.applied(counts)) : false}
          className={classNames(style['switches-item'], {
            [style['switches-item-active']]: item.panel == currentPanel,
            [style['switches-item-applied']]: item.applied ? item.applied(counts) : false
          })}
          // one tab per panel: it reads as selected when its panel is up, and Enter or Space opens it
          role="tab"
          aria-selected={item.panel == currentPanel}
          tabIndex={0}
          onClick={() => onPanelChange(item.panel)}
          onKeyDown={event => {
            if ('Enter' !== event.key && ' ' !== event.key) return
            event.preventDefault()
            onPanelChange(item.panel)
          }}
        >
          {/* the icon font draws a private-use glyph, which would otherwise lead the switch's accessible name */}
          <i className={`icon-aytmfd-${item.icon}`} aria-hidden></i>
          <span className={style['switches-item-text']}>{item.label}</span>
        </div>
      ))}
    </>
  )
}

SidebarSwitches.propTypes = {
  model: PropTypes.object,
  features: PropTypes.object,
  currentPanel: PropTypes.string,
  onPanelChange: PropTypes.func
}

SidebarSwitches.displayName = 'SidebarSwitches'

export default SidebarSwitches
